export default (inMin, inMax, outMin, outMax, value) =>
  ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
